module.exports = __webpack_public_path__ + "img/upgrade-s.bb0559dd.svg";